<script setup lang="ts">
import SharedPartialHeader from '@pkg/site-chrome/components/PartialHeader.vue';
import type { LocationAutocompleteApi, MainNav } from '@pkg/site-chrome';

/**
 * App-local entry for Nuxt auto-import. Implementation lives in @pkg/site-chrome.
 */
const props = defineProps<{
  menuContent: MainNav | null;
  enableLocationSearch?: boolean;
  locationAutocomplete?: LocationAutocompleteApi | null;
}>();
</script>

<template>
  <SharedPartialHeader
    :menu-content="props.menuContent"
    :enable-location-search="props.enableLocationSearch"
    :location-autocomplete="props.locationAutocomplete"
  >
    <template v-if="$slots.logo" #logo>
      <slot name="logo" />
    </template>
  </SharedPartialHeader>
</template>
